<template>
    <MenuItem
        v-slot="{ close }"
        :data-spec-class="dataSpecClass"
    >
        <BaseLink
            v-bind="$attrs"
            :class="classObjectMenuItem"
            :to="to"
            data-spec-class="dropdown_menu_item__link"
            @click="handleClick(close)"
        >
            <slot />
        </BaseLink>
    </MenuItem>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { MenuItem } from '@headlessui/vue';
import { RouteLocationNormalized } from 'vue-router';
import { Theme } from '@/types';

interface Props {
    to?: RouteLocationNormalized;
    dataSpecClass?: string;
    theme?: Theme;
}

const props = withDefaults(defineProps<Props>(), {
    to: undefined,
    dataSpecClass: 'dropdown_menu_item',
    theme: Theme.Normal,
});

const emit = defineEmits<{
    click: [close: () => void];
}>();

const classObjectMenuItem = computed(() => ({
    'block px-4 py-2 text-sm !no-underline hover:bg-gray-100 dark:hover:bg-gray-600': true,
    '!text-secondary': props.theme === Theme.Normal,
    'text-brand': props.theme === Theme.Primary,
    '!text-red': props.theme === Theme.Danger,
}));

const handleClick = (close: () => void) => {
    emit('click', close);
};
</script>

<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>
